import { useEffect, useState } from "react";
import api from "@/lib/api";
import { trackEvent } from "@/lib/analytics";

let cache = null;
let inflight = null;

export function loadLeadFormConfigs() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = api.get("/lead-forms/config")
      .then((r) => { cache = r.data.forms || {}; return cache; })
      .catch(() => { cache = {}; return cache; });
  }
  return inflight;
}

const FALLBACK = { active: true, title: "", subtitle: "", button_label: "", success_title: "", success_message: "", fields: [] };

export function useLeadForm(key, open) {
  const [cfg, setCfg] = useState((cache && cache[key]) || FALLBACK);
  useEffect(() => {
    loadLeadFormConfigs().then((forms) => setCfg(forms[key] || FALLBACK));
  }, [key]);
  useEffect(() => {
    if (open) trackEvent("form_view", { form: key });
  }, [open, key]);
  return cfg;
}

export function invalidateLeadFormCache() {
  cache = null;
  inflight = null;
}

export const leadField = (cfg, key, fallback = {}) =>
  (cfg.fields || []).find((f) => f.key === key) || { visible: true, required: false, ...fallback };
